// Add your custom JS here.

document.addEventListener('DOMContentLoaded', function () {
	// Find all figure elements with the class 'has-yt-video'
	const videoFigures = document.querySelectorAll('.wp-block-image.has-yt-video');

	videoFigures.forEach(figure => {
		// Create the play icon element dynamically
		const playIcon = document.createElement('div');
		playIcon.classList.add('yt-play-icon');

		// Append the play icon to the figure
		figure.appendChild(playIcon);

		// Add a click event listener to each figure
		figure.addEventListener('click', function () {
			const youtubeUrl = figure.id; // Get the YouTube URL from the figure ID
			const videoId = youtubeUrl.split('v=')[1]; // Extract the YouTube video ID from the URL

			// Create the YouTube embed iframe
			const iframe = document.createElement('iframe');
			iframe.width = '100%';
			iframe.height = '100%';
			iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
			iframe.setAttribute('allowfullscreen', true);

			// Create the wrapper div and figure structure for the iframe
			const embedWrapper = document.createElement('div');
			embedWrapper.className = 'wp-block-embed__wrapper';
			embedWrapper.appendChild(iframe);

			const embedFigure = document.createElement('figure');
			embedFigure.className = 'wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio';
			embedFigure.appendChild(embedWrapper);

			// Remove the play icon and replace the image with the iframe
			figure.innerHTML = ''; // Clear the existing content
			figure.appendChild(embedFigure); // Append the new YouTube embed structure
		});
	});

  // Handle category filter button click
  const categoryButtons = document.querySelectorAll(".category-filter button");
  const paginationContainer = document.querySelector('.wp-block-query-pagination'); // Pagination container

  // Add event listener to each category button
  categoryButtons.forEach(button => {
    button.addEventListener("click", function () {
      // Remove 'active' class from all buttons and add to the clicked button
      categoryButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      const categoryId = this.getAttribute("data-category");

      const queryArgs = {
        category: categoryId ? [categoryId] : [], // Category as an array or empty array if no category
        paged: 1, // Start from page 1 for the new category
        perPage: 100, // Large number to ensure no pagination on filtered results
      };

      fetchPosts(queryArgs); // Fetch all posts for the selected category
      paginationContainer.style.display = 'none'; // Hide pagination when a category is selected
    });
  });

  // Fetch posts function
  function fetchPosts(queryArgs) {
    // Construct the query URL
    let queryUrl = `/wp-json/wp/v2/posts?per_page=${queryArgs.perPage}&page=${queryArgs.paged}&_embed`;
    if (queryArgs.category.length) {
      queryUrl += `&categories=${queryArgs.category.join(',')}`; // Pass categories as a comma-separated list
    }

    fetch(queryUrl)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch posts');
        return response.json();
      })
      .then(data => {
        const postsContainer = document.querySelector('.news-query .wp-block-post-template');
        postsContainer.innerHTML = ''; // Clear current posts

        data.forEach(post => {
          // Featured Image
          const featuredImage = post.featured_blog || ''; // Use the 'featured-blog' image size

          // Post Date
          const postDate = new Date(post.date).toLocaleDateString(); // Format post date

          // Categories
          const categories = post._embedded?.['wp:term']?.[0]?.map(term => term.name).join(', ') || 'News'; // Default to 'News'

          // ACF Fields (custom fields)
          const noLink = post.acf?.no_link; // Assuming ACF data is available in REST API
          const externalLink = post.acf?.external_link;

          // Post Title
          let postTitle;
          if (noLink) {
            // No link at all
            postTitle = `<h2 class="wp-block-post-title">${post.title.rendered}</h2>`;
          } else if (externalLink) {
            // External link
            postTitle = `<h2 class="wp-block-post-title"><a href="${externalLink}" target="_blank">${post.title.rendered}</a></h2>`;
          } else {
            // Default post link
            postTitle = `<h2 class="wp-block-post-title"><a href="${post.link}">${post.title.rendered}</a></h2>`;
          }

          // Post Item Template
          const postItem = `
            <li class="wp-block-post post-${post.id} post type-post status-${post.status} format-${post.format} has-post-thumbnail hentry category-${categories.toLowerCase().replace(/\s+/g, '-')}">
              <figure class="wp-block-post-featured-image">
                <img decoding="async" width="500" height="500" src="${featuredImage}" class="attachment-featured-blog size-featured-blog wp-post-image" alt="${post.title.rendered}" style="object-fit:cover;">
              </figure>
              <div class="wp-block-post-date">
                <time datetime="${post.date}">${postDate}</time>
              </div>
              <div class="taxonomy-category wp-block-post-terms">${categories}</div>
              ${postTitle} <!-- Dynamic post title based on ACF conditions -->
            </li>
          `;

          postsContainer.innerHTML += postItem;
        });
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });
  }

  // Add "All" button functionality
  const allButton = document.querySelector(".category-filter .all-button");

  if (allButton) {
    allButton.addEventListener("click", function () {
      // Remove 'active' class from all buttons
      categoryButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      // Redirect to the specific URL for "All" selection
      window.location.href = "?query-12-page=1&cst";

      // Optionally, if you need to fetch posts instead of a page reload, you can fetch all posts:
      // const queryArgs = {
      //   category: [], // No category filter, get all posts
      //   paged: 1,
      //   perPage: 12, // Restore pagination for "All"
      // };
      // fetchPosts(queryArgs); // Fetch all posts without filter
      // paginationContainer.style.display = 'flex'; // Show pagination again when "All" is clicked
    });
  }

});